export const VUEX_ASSIGNMENTS_FETCH_COORDINATORS = 'VUEX_ASSIGNMENTS_FETCH_COORDINATORS'
export const VUEX_ASSIGNMENTS_CREATE = 'VUEX_ASSIGNMENTS_CREATE'
export const VUEX_ASSIGNMENTS_PATCH_UPDATE = 'VUEX_ASSIGNMENTS_PATCH_UPDATE'
export const VUEX_ASSIGNMENTS_DELETE = 'VUEX_ASSIGNMENTS_DELETE'
